import { render, staticRenderFns } from "./NewBuild.vue?vue&type=template&id=b2e8cda2&scoped=true&"
import script from "./NewBuild.vue?vue&type=script&lang=js&"
export * from "./NewBuild.vue?vue&type=script&lang=js&"
import style0 from "./NewBuild.vue?vue&type=style&index=0&id=b2e8cda2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e8cda2",
  null
  
)

export default component.exports